import React, { Suspense } from 'react';
import { getContentTypeConfig } from './config';

const renderContentType = (Component, data) => {
    return (
        <Component {...data}>
            {data.children.map((childTreeItem, i) => {
                if (childTreeItem?.contentType === 'products') {
                    childTreeItem.isDeals = childTreeItem.cssClasses.includes('deals');
                }
                return <ContentTypeFactory key={i} data={childTreeItem} />
            })}
        </Component>
    );
};

const ContentTypeFactory = ({ data }) => {
    const { isHidden, ...props } = data;

    if (isHidden) {
        return null;
    }

    const contentTypeConfig = getContentTypeConfig(props.contentType);
    if (contentTypeConfig && contentTypeConfig.component) {
        const Component = renderContentType(contentTypeConfig.component, props);

        return <Suspense fallback={<></>}>{Component}</Suspense>;
    }

    return null;
};

export default ContentTypeFactory;
